import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-stock-corr-codes',
  templateUrl: './stock-corr-codes.component.html',
  styleUrls: ['./stock-corr-codes.component.css']
})
export class StockCorrCodesComponent implements OnInit {
    public itemsListStockCorrectionCodes: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadStockCorrectionCodes(): Promise<void> {
        this.itemsListStockCorrectionCodes = await this.datatask.Post(2482);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'stockcorrcode':
                this.stateService?.go('stockcorrcode', { stockcorrcode_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadStockCorrectionCodes();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockCorrCodes', {
//        templateUrl: 'views/components/views/stockCorrCodes/stockCorrCodes.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'stockCorrCodesService', function (stateService, stockCorrCodesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListStockCorrectionCodes: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            let loadStockCorrectionCodes = function () {
//                stockCorrCodesService.listStockCorrectionCodes().then(function (result) {
//                    angular.copy(result, vm.model.itemsListStockCorrectionCodes);
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'stockcorrcode':
//                        go({ stockcorrcode_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadStockCorrectionCodes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
